import symbolName from "@/util/symbol-name.mjs";

export const GAME_SYMBOL_LOL: unique symbol = symbolName("lol");
